export function formatPrecision(num: number, precision: number): number {
  return parseFloat(
    num.toLocaleString('en-US', {
      maximumFractionDigits: precision
    })
  );
}
